import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function Terms() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <div className="max-w-3xl mx-auto px-6 py-12">
        {/* Back to Login */}
        <Link
          to="/login"
          className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Login
        </Link>

        <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
        <p className="text-white/60 mb-8">Last updated: February 2026</p>

        <div className="space-y-8 text-white/80">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing or using aiia services, you agree to be bound by
              these Terms of Service. If you do not agree to these terms, please
              do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              2. Description of Service
            </h2>
            <p>
              aiia provides AI-powered business automation tools and
              integrations with Odoo ERP systems. Our services include Business
              Operation Bots (BoB), API integrations, and management dashboards.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              3. Account Registration
            </h2>
            <p className="mb-3">To use our services, you must:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Be at least 18 years old or have parental consent</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              4. Subscription and Billing
            </h2>
            <p className="mb-3">
              Our services are offered on a subscription basis. By subscribing,
              you agree to:
            </p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Pay all fees associated with your selected plan</li>
              <li>Provide valid payment information</li>
              <li>Accept automatic renewal unless cancelled</li>
              <li>14-day free trial for new users (no credit card required)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              5. Acceptable Use
            </h2>
            <p className="mb-3">You agree not to:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe on intellectual property rights</li>
              <li>Transmit malicious code or attempt to breach security</li>
              <li>Use the service for unauthorized commercial purposes</li>
              <li>Attempt to reverse engineer our software</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              6. Data Ownership
            </h2>
            <p>
              You retain ownership of all data you upload to our platform. We do
              not claim ownership of your content. You grant us a license to
              process your data solely to provide our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              7. Service Availability
            </h2>
            <p>
              We strive for 99.9% uptime but do not guarantee uninterrupted
              service. Scheduled maintenance will be communicated in advance
              when possible.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              8. Limitation of Liability
            </h2>
            <p>
              To the maximum extent permitted by law, aiia shall not be liable
              for any indirect, incidental, special, consequential, or punitive
              damages resulting from your use of our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              9. Termination
            </h2>
            <p>
              We may terminate or suspend your account for violation of these
              terms. You may cancel your subscription at any time through your
              account settings. Upon termination, your data will be retained for
              30 days before deletion.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              10. Changes to Terms
            </h2>
            <p>
              We may update these terms from time to time. We will notify you of
              significant changes via email or through our platform. Continued
              use after changes constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              11. Contact
            </h2>
            <p>
              For questions about these terms, please contact us at{" "}
              <a
                href="mailto:legal@aiia.io"
                className="text-[#1283EB] hover:underline"
              >
                legal@aiia.io
              </a>
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center text-sm text-white/40">
          <p>&copy; {new Date().getFullYear()} aiia. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default Terms;
